// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var ViewStack = require("../ViewStack.bs.js");
var Text__Jsx3 = require("../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var Attachments = require("./Attachments.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Dialog__Jsx3 = require("../../../uikit/reason/molecules/Dialog/Dialog__Jsx3.bs.js");
var Buttons__Jsx3 = require("../../../uikit/reason/atoms/Buttons/Buttons__Jsx3.bs.js");

function UnsupportedAttachmentsDialog(props) {
  var onDismiss = props.onDismiss;
  var files = props.files;
  var isOpen = files.length !== 0;
  return React.createElement(Dialog__Jsx3.make, {
              title: "Unsupported Files",
              isOpen: isOpen,
              ariaLabel: "Unsupported Files",
              onDismiss: onDismiss,
              children: React.createElement(ViewStack.make, {
                    space: "lg",
                    flexDirection: "column",
                    children: Caml_option.some(null)
                  }, React.createElement(Text__Jsx3.make, {
                        fontSize: {
                          NAME: "px",
                          VAL: 15
                        },
                        lineHeight: {
                          NAME: "float",
                          VAL: 1.5
                        },
                        children: null
                      }, Attachments.makeUnsupportedFileErrorText(files), React.createElement("br", undefined), React.createElement("br", undefined), "You can attach images (JPEG, PNG, GIF, PNG), videos (MP4, Quicktime), PDFs, documents and spreadsheets"), React.createElement(ViewStack.make, {
                        width: {
                          NAME: "percent",
                          VAL: 100
                        },
                        justifyContent: "flexEnd",
                        flexDirection: "row",
                        children: Caml_option.some(React.createElement(Buttons__Jsx3.PrimaryButton.make, {
                                  onClick: (function (param) {
                                      Curry._1(onDismiss, undefined);
                                    }),
                                  size: "large",
                                  children: "Dismiss"
                                }))
                      }))
            });
}

var make = UnsupportedAttachmentsDialog;

exports.make = make;
/* react Not a pure module */
